export default __webpack_public_path__ + "static/media/Group 174068.34fe9e0f.svg";